import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ContentText extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ContentText {
    return new ContentText(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
